import Header from "../../components/Header";

const AdminPage = () => {
  const auth_name = localStorage.getItem("auth_username");

  return (
    <div className="main-body border-l-orange-100 md:pb-10">
      <Header />
      <main className="w-full">
        <div className="mt-3 shadow-[0_0_10px_rgba(0,0,0,0.25)] rounded-md p-3 max-w-screen-lg mx-auto text-black">
          <div className="py-3 pl-2">
            <h2 className="text-2xl">
              Добро пожаловать, {auth_name ? auth_name : "... как ты сюда попал?"}!
            </h2>
          </div>
          <button
            onClick={(_e) => (window.location.href = "/task_list_admin")}
            className="w-full hover:bg-inherit shadow-[0_0_3px_rgba(0,0,0,0.25)] text-lg p-2 mt-3 rounded-md"
          >
            Управление задачами
          </button>
          <button
            onClick={(_e) => (window.location.href = "/create_task")}
            className="w-full hover:bg-inheri shadow-[0_0_3px_rgba(0,0,0,0.25)] text-lg p-2 mt-2 rounded-md"
          >
            Создание задачи
          </button>
        </div>
      </main>
    </div>
  );
};

export default AdminPage;
